// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {Divider, Popover, Dialog, Message} from 'element-ui'
import infiniteScroll from 'vue-infinite-scroll'
import Directives from './directives'
import VueLazyload from "vue-lazyload";

import '@/icons'

import 'normalize.css'
import 'animate.css'
import '@/assets/css/font.css'
import '@/styles/index.scss'

Vue.config.productionTip = false;

Vue.use(Divider);
Vue.use(Dialog);
Vue.use(Popover);
Vue.use(Directives);
Vue.use(infiniteScroll);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize'],
});

Vue.prototype.$message = Message;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js